export default {
  sections: {
    title: {
      title: 'Ordre bekræftet',
      description: 'Dit gavekort er købt',
    },
    instructions: {
      title: 'Tjek din e-mail',
      description:
        'Vi har sendt dine gavekortoplysninger og din kvittering til din e-mailadresse. Gavekortkoden ankommer inden for 5-10 minutter.',
    },
    details: {
      total: 'I alt',
      order_number: 'Ordrenummer',
    },
    footer: {
      help: 'Vores teknologipartner Foodamigos hjælper os med at administrere gavekort. Hvis du ikke modtager gavekortet eller ikke kan finde det, kan du kontakte dem på {{email}}',
      questions: 'Hvis du har generelle spørgsmål om indløsning, kan du kontakte os direkte på {{email}}',
    },
  },
  buttons: {
    go_home: 'Tilbage til forsiden',
    download_pdfs: 'Download gavekort som PDF',
  },
};
